var map = {
	"./birthday/arabic/page-1.mp3": "87ac",
	"./birthday/arabic/page-2.mp3": "7a2b",
	"./birthday/arabic/page-3.mp3": "9640",
	"./birthday/arabic/page-4.mp3": "3e8e",
	"./birthday/arabic/page-5.mp3": "7e29",
	"./birthday/arabic/page-6.mp3": "fca7",
	"./birthday/bengali/page-1.mp3": "7c93",
	"./birthday/bengali/page-2.mp3": "8280",
	"./birthday/bengali/page-3.mp3": "e295",
	"./birthday/bengali/page-4.mp3": "a742",
	"./birthday/bengali/page-5.mp3": "5308",
	"./birthday/bengali/page-6.mp3": "ca59",
	"./birthday/dari/page-1.mp3": "680e",
	"./birthday/dari/page-2.mp3": "9cf5",
	"./birthday/dari/page-3.mp3": "a0b5",
	"./birthday/dari/page-4.mp3": "e846",
	"./birthday/dari/page-5.mp3": "3ecf",
	"./birthday/dari/page-6.mp3": "0a53",
	"./birthday/english/page-1.mp3": "6f24",
	"./birthday/english/page-2.mp3": "938c",
	"./birthday/english/page-3.mp3": "00c2",
	"./birthday/english/page-4.mp3": "2824",
	"./birthday/english/page-5.mp3": "9681",
	"./birthday/english/page-6.mp3": "538b",
	"./birthday/gujarati/page-1.mp3": "d82b",
	"./birthday/gujarati/page-2.mp3": "fd9b",
	"./birthday/gujarati/page-3.mp3": "9abe",
	"./birthday/gujarati/page-4.mp3": "9251",
	"./birthday/gujarati/page-5.mp3": "1ecb",
	"./birthday/gujarati/page-6.mp3": "6d0a",
	"./birthday/pashto/page-1.mp3": "82cc",
	"./birthday/pashto/page-2.mp3": "93e7",
	"./birthday/pashto/page-3.mp3": "21853",
	"./birthday/pashto/page-4.mp3": "aaf7",
	"./birthday/pashto/page-5.mp3": "f536",
	"./birthday/pashto/page-6.mp3": "d545",
	"./birthday/polish/page-1.mp3": "c9d1",
	"./birthday/polish/page-2.mp3": "177a",
	"./birthday/polish/page-3.mp3": "362d",
	"./birthday/polish/page-4.mp3": "346b",
	"./birthday/polish/page-5.mp3": "7730",
	"./birthday/polish/page-6.mp3": "72f6",
	"./birthday/punjabi/page-1.mp3": "7fa4",
	"./birthday/punjabi/page-2.mp3": "de9a",
	"./birthday/punjabi/page-3.mp3": "096a",
	"./birthday/punjabi/page-4.mp3": "fe0e",
	"./birthday/punjabi/page-5.mp3": "d85c",
	"./birthday/punjabi/page-6.mp3": "ac6a",
	"./birthday/romanian/page-1.mp3": "6334",
	"./birthday/romanian/page-2.mp3": "69b4",
	"./birthday/romanian/page-3.mp3": "af54",
	"./birthday/romanian/page-4.mp3": "bfae",
	"./birthday/romanian/page-5.mp3": "d05d",
	"./birthday/romanian/page-6.mp3": "a4dc",
	"./birthday/ukrainian/page-1.mp3": "56a3",
	"./birthday/ukrainian/page-2.mp3": "666a",
	"./birthday/ukrainian/page-3.mp3": "397b",
	"./birthday/ukrainian/page-4.mp3": "9291",
	"./birthday/ukrainian/page-5.mp3": "412d",
	"./birthday/ukrainian/page-6.mp3": "dc3d",
	"./birthday/urdu/page-1.mp3": "27ad",
	"./birthday/urdu/page-2.mp3": "13d5",
	"./birthday/urdu/page-3.mp3": "5bb0",
	"./birthday/urdu/page-4.mp3": "9c57",
	"./birthday/urdu/page-5.mp3": "25d9",
	"./birthday/urdu/page-6.mp3": "aa9b",
	"./wayout/arabic/page-1.mp3": "e168",
	"./wayout/arabic/page-2.mp3": "9cb9",
	"./wayout/arabic/page-3.mp3": "ff69",
	"./wayout/arabic/page-4.mp3": "eeae",
	"./wayout/arabic/page-5.mp3": "05c5",
	"./wayout/arabic/page-6.mp3": "7d90",
	"./wayout/arabic/page-7.mp3": "6abc",
	"./wayout/bengali/page-1.mp3": "edfd",
	"./wayout/bengali/page-2.mp3": "371e",
	"./wayout/bengali/page-3.mp3": "60bf",
	"./wayout/bengali/page-4.mp3": "6b49",
	"./wayout/bengali/page-5.mp3": "e091",
	"./wayout/bengali/page-6.mp3": "d16e",
	"./wayout/bengali/page-7.mp3": "7e3f",
	"./wayout/dari/page-1.mp3": "5489",
	"./wayout/dari/page-2.mp3": "7a30",
	"./wayout/dari/page-3.mp3": "a41c",
	"./wayout/dari/page-4.mp3": "e1a3",
	"./wayout/dari/page-5.mp3": "488c",
	"./wayout/dari/page-6.mp3": "967b",
	"./wayout/dari/page-7.mp3": "5cec",
	"./wayout/english/page-1.mp3": "483e",
	"./wayout/english/page-2.mp3": "0c4d",
	"./wayout/english/page-3.mp3": "383a",
	"./wayout/english/page-4.mp3": "4190",
	"./wayout/english/page-5.mp3": "085c",
	"./wayout/english/page-6.mp3": "31a0",
	"./wayout/english/page-7.mp3": "a481",
	"./wayout/gujarati/page-1.mp3": "8348",
	"./wayout/gujarati/page-2.mp3": "cc68",
	"./wayout/gujarati/page-3.mp3": "19ff",
	"./wayout/gujarati/page-4.mp3": "bbb7",
	"./wayout/gujarati/page-5.mp3": "b8a2",
	"./wayout/gujarati/page-6.mp3": "ccc2",
	"./wayout/gujarati/page-7.mp3": "f051",
	"./wayout/pashto/page-1.mp3": "eaef",
	"./wayout/pashto/page-2.mp3": "de96",
	"./wayout/pashto/page-3.mp3": "8505",
	"./wayout/pashto/page-4.mp3": "00a4",
	"./wayout/pashto/page-5.mp3": "61b8",
	"./wayout/pashto/page-6.mp3": "92cf",
	"./wayout/pashto/page-7.mp3": "2cd9",
	"./wayout/polish/page-1.mp3": "3650",
	"./wayout/polish/page-2.mp3": "5876",
	"./wayout/polish/page-3.mp3": "c0af",
	"./wayout/polish/page-4.mp3": "28fc",
	"./wayout/polish/page-5.mp3": "2009",
	"./wayout/polish/page-6.mp3": "7a39",
	"./wayout/polish/page-7.mp3": "2aba",
	"./wayout/punjabi/page-1.mp3": "0f5e",
	"./wayout/punjabi/page-1_alt.mp3": "def6",
	"./wayout/punjabi/page-2.mp3": "080b",
	"./wayout/punjabi/page-2_alt.mp3": "ab38",
	"./wayout/punjabi/page-3.mp3": "2d17",
	"./wayout/punjabi/page-4.mp3": "e3bb",
	"./wayout/punjabi/page-5.mp3": "e1e4",
	"./wayout/punjabi/page-6.mp3": "7243",
	"./wayout/punjabi/page-7.mp3": "f398",
	"./wayout/romanian/page-1.mp3": "835e",
	"./wayout/romanian/page-2.mp3": "66b7",
	"./wayout/romanian/page-3.mp3": "3eb8",
	"./wayout/romanian/page-4.mp3": "8b59",
	"./wayout/romanian/page-5.mp3": "7088",
	"./wayout/romanian/page-6.mp3": "d2e7",
	"./wayout/romanian/page-7.mp3": "db22",
	"./wayout/ukrainian/page-1.mp3": "043d",
	"./wayout/ukrainian/page-2.mp3": "23e6",
	"./wayout/ukrainian/page-2_alt.mp3": "cd39",
	"./wayout/ukrainian/page-3.mp3": "d522",
	"./wayout/ukrainian/page-4.mp3": "da82",
	"./wayout/ukrainian/page-5.mp3": "4069",
	"./wayout/ukrainian/page-6.mp3": "75a6",
	"./wayout/ukrainian/page-7.mp3": "b6fa",
	"./wayout/ukrainian/page-7_alt.mp3": "e263",
	"./wayout/urdu/page-1.mp3": "7aaa",
	"./wayout/urdu/page-2.mp3": "1808",
	"./wayout/urdu/page-3.mp3": "2dc3",
	"./wayout/urdu/page-4.mp3": "006c",
	"./wayout/urdu/page-5.mp3": "b333",
	"./wayout/urdu/page-6.mp3": "b890",
	"./wayout/urdu/page-7.mp3": "c81b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c6f";